import { BRAND } from "../risikoanalyseStep/tokens";

/**
 * Motiv rechts neben der Überschrift — je Vertragsart eines, plus eines für
 * die Vertragsübersicht. Gezeichnet wie die Motive der Immobilien- und
 * KFZ-Vertragsmaske: flache Formen in Aubergine und Gold, keine Fremdgrafik.
 */

const W = 140;
const H = 96;

const Wrap = ({ children }: { children: React.ReactNode }) => (
  <svg width={W} height={H} viewBox="0 0 140 96" fill="none" aria-hidden="true">
    {children}
  </svg>
);

/** Übersicht: fünf Vertragsarten nebeneinander. */
const Uebersicht = () => (
  <Wrap>
    <rect x="10" y="24" width="34" height="48" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <rect x="52" y="24" width="34" height="48" rx="4" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <rect x="94" y="24" width="34" height="48" rx="4" fill={BRAND.gold} stroke={BRAND.ink} strokeWidth="1.5" />
    <path d="M17 36h20M17 44h14M59 36h20M59 44h14M101 36h20M101 44h14" stroke={BRAND.muted} strokeWidth="1.5" strokeLinecap="round" />
    <rect x="17" y="56" width="20" height="8" rx="2" fill={BRAND.gold} />
    <rect x="59" y="56" width="20" height="8" rx="2" fill={BRAND.gold} />
    <rect x="101" y="56" width="20" height="8" rx="2" fill={BRAND.bg} />
  </Wrap>
);

/** Warentransport: Paket auf dem Weg von A nach B. */
const Warentransport = () => (
  <Wrap>
    <path d="M16 74h108" stroke={BRAND.muted} strokeWidth="1.5" strokeDasharray="4 4" strokeLinecap="round" />
    <circle cx="20" cy="74" r="5" fill={BRAND.purple} />
    <circle cx="120" cy="74" r="5" fill={BRAND.gold} />
    <path d="M44 26l26-12 26 12v28L70 66 44 54V26z" fill={BRAND.gold} stroke={BRAND.ink} strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M44 26l26 12 26-12M70 38v28" stroke={BRAND.ink} strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M57 20l26 12" stroke={BRAND.purple} strokeWidth="3" strokeLinecap="round" />
  </Wrap>
);

/** Werkverkehr: eigenes Fahrzeug mit Ladung. */
const Werkverkehr = () => (
  <Wrap>
    <rect x="14" y="30" width="58" height="34" rx="3" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <path d="M72 40h20l14 14v10H72V40z" fill={BRAND.gold} stroke={BRAND.ink} strokeWidth="1.5" strokeLinejoin="round" />
    <rect x="78" y="44" width="14" height="10" rx="1.5" fill={BRAND.bg} stroke={BRAND.ink} strokeWidth="1.2" />
    <rect x="24" y="38" width="16" height="16" rx="2" fill={BRAND.purple} />
    <rect x="44" y="42" width="12" height="12" rx="2" fill={BRAND.gold} />
    <circle cx="38" cy="70" r="8" fill={BRAND.ink} />
    <circle cx="38" cy="70" r="3" fill={BRAND.white} />
    <circle cx="94" cy="70" r="8" fill={BRAND.ink} />
    <circle cx="94" cy="70" r="3" fill={BRAND.white} />
  </Wrap>
);

/** Frachtführerhaftpflicht: Haftungsschild über der Transportkette. */
const Frachtfuehrer = () => (
  <Wrap>
    <path d="M70 12l30 11v21c0 17-13 30-30 36-17-6-30-19-30-36V23l30-11z" fill={BRAND.purple} />
    <path d="M58 46l9 9 17-18" stroke={BRAND.gold} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="24" cy="80" r="6" fill={BRAND.gold} />
    <circle cx="70" cy="86" r="6" fill={BRAND.gold} />
    <circle cx="116" cy="80" r="6" fill={BRAND.gold} />
    <path d="M30 80h34M76 86h34" stroke={BRAND.muted} strokeWidth="1.5" strokeDasharray="3 3" strokeLinecap="round" />
  </Wrap>
);

/** Messe: Stand mit Exponat. */
const Messe = () => (
  <Wrap>
    <path d="M18 30h104l-8-14H26l-8 14z" fill={BRAND.gold} stroke={BRAND.ink} strokeWidth="1.5" strokeLinejoin="round" />
    <rect x="22" y="30" width="96" height="42" fill={BRAND.bg} stroke={BRAND.purple} strokeWidth="2" />
    <rect x="34" y="44" width="26" height="28" fill={BRAND.purple} />
    <circle cx="90" cy="52" r="12" fill={BRAND.gold} stroke={BRAND.ink} strokeWidth="1.5" />
    <path d="M14 76h112" stroke={BRAND.ink} strokeWidth="2.5" strokeLinecap="round" />
  </Wrap>
);

/** Reisegepäck: Koffer auf Geschäftsreise. */
const Reisegepaeck = () => (
  <Wrap>
    <path d="M54 28v-6a6 6 0 016-6h20a6 6 0 016 6v6" stroke={BRAND.ink} strokeWidth="2.5" strokeLinecap="round" />
    <rect x="34" y="28" width="72" height="46" rx="6" fill={BRAND.gold} stroke={BRAND.ink} strokeWidth="1.5" />
    <path d="M70 28v46" stroke={BRAND.ink} strokeWidth="1.5" strokeDasharray="4 3" />
    <rect x="46" y="44" width="14" height="10" rx="2" fill={BRAND.bg} />
    <rect x="80" y="44" width="14" height="10" rx="2" fill={BRAND.bg} />
    <path d="M46 78v6M94 78v6" stroke={BRAND.purple} strokeWidth="3" strokeLinecap="round" />
    <circle cx="20" cy="52" r="8" fill={BRAND.purple} />
  </Wrap>
);

const MOTIVE: Record<string, () => JSX.Element> = {
  uebersicht: Uebersicht,
  warentransport: Warentransport,
  werkverkehr: Werkverkehr,
  frachtfuehrer: Frachtfuehrer,
  messe: Messe,
  reisegepaeck: Reisegepaeck,
};

const StepHero = ({ kind }: { kind: string }) => {
  const Motiv = MOTIVE[kind];
  return Motiv ? <Motiv /> : null;
};

export default StepHero;
